import AOS from 'aos';
import lazySizes from 'lazysizes';

AOS.init();
lazySizes.init();

// additional modules
import './menu.js';
import './email.js';
import './homepage-video.js';
import './homepage-stats.js';

// adds outlines when the user hits tab
const handleFirstTab = e => {
  if (e.keyCode === 9) {
      // tab key
      document.body.classList.add('user-is-tabbing');
      window.removeEventListener('keydown', handleFirstTab);
  }
};

window.addEventListener('keydown', handleFirstTab);
